import { SnMapClusterPoint } from '@lib/api';
import { SnLonLatBounds } from '@lib/geo/helpers';
import { COLORS } from '@lib/ui/theme';

import { GoogleMap } from '../../map';
import { GoogleMapMarker } from './marker';
import { IGoogleMapMarkerOptions } from './marker-options';
import { GoogleMapMarkerType } from './marker-types';

export class GoogleMapClusterMarker extends GoogleMapMarker {
  constructor(public readonly cluster: SnMapClusterPoint, options?: IGoogleMapMarkerOptions) {
    super({
      type: GoogleMapMarkerType.CIRCLE,
      lonLat: cluster.geometry.coordinates,
      style: {
        fillColor: COLORS['base-800'],
        strokeColor: COLORS['grey-400'],
        strokeWeight: 1,
        scale: 1.4,
      },
      badge: {
        value: cluster.properties.objects,
        color: 'secondary',
      },
      ...options,
    });

    this.on('click').subscribe(this._onClusterClick.bind(this));
  }

  private _onClusterClick(): void {
    fsClusterClick(this.cluster, this.map);
  }
}

export const fsClusterClick = (cluster: SnMapClusterPoint, map: GoogleMap) => {
  if (cluster.bbox) {
    const lonLatBounds = SnLonLatBounds.fromGeojsonBBox(cluster.bbox);
    const bounds = SnLonLatBounds.convertToLatLng(lonLatBounds);

    map.panToBounds(lonLatBounds);
    map.setCenter(cluster.geometry.coordinates);
    map.mapInstance.fitBounds(bounds);
  }
};
